import { useForm, Controller } from "react-hook-form";
import { Pattern } from "../../packages/services";
import { CountrySelector, FormContainer, TextInput, SelectInput } from "../shared";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { CREATE_FORM } from "./query";
import { ROUTE_AUTH_APP_LIST, clearCache } from "../../utils";

const CreateForm = ({ appName }) => {
    const applicationList =
        (appName === "abbvie-pro" && [
            { id: "abbvie_pro", name: "Abbvie Pro" },
            { id: "abbvie_pro_medical", name: "Abbvie Pro Medical" },
        ]) ||
        (appName === "allergan-pro" && [
            { id: "allergan_pro", name: "Allergan Pro" },
            { id: "allergan_pro_medical", name: "Allergan Pro Medical" },
        ]);

    const cacheName =
        (appName === ROUTE_AUTH_APP_LIST.ABBVIEPRO && "allAbbvieProSystemSettings") ||
        (appName === ROUTE_AUTH_APP_LIST.ALLERGANPRO && "allAllerganProSystemSettings");

    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        setValue,
        clearErrors,
    } = useForm({
        mode: "onChange",
    });

    const countryAvailablity = watch("countryAvailablity");

    const { submitMutation, loading } = useGlobalMutation(CREATE_FORM, (cache) => {
        clearCache(cache, cacheName);
    });

    const submitAction = handleSubmit(async (data) => {
        const { formKey, formText, category, country, countryName } = data;

        const variables = {
            formSystemSettings: {
                formKey,
                formText,
                category,
                country: country || countryName.toUpperCase(),
            },
        };
        const dataPath = "createAbbvieProSystemSettings";
        const isResultNull = await submitMutation(variables, dataPath, "Form created successfully");
        isResultNull === null && reset();
    });

    return (
        <FormContainer
            submitAction={submitAction}
            backUrl={`/${appName}/forms`}
            customClass="custom-shadow p-5"
            title="Create Form"
            loading={loading}
        >
            <h3 className="mb-5">Create Form</h3>

            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id="formKey"
                        labelText="Form Key"
                        {...register("formKey", {
                            required: true,
                            pattern: Pattern.nameWithoutSpace,
                        })}
                        isInvalid={!!errors.formKey}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="formText"
                        labelText="Form Text"
                        {...register("formText", {
                            required: true,
                            pattern: Pattern.name,
                        })}
                        isInvalid={!!errors.formText}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <SelectInput
                        id="category"
                        labelText="Application Name"
                        {...register("category", {
                            required: true,
                        })}
                        options={applicationList}
                        isInvalid={!!errors.category}
                        required
                    />
                </div>
                <div className="col-md-6">
                    {countryAvailablity ? (
                        <TextInput
                            id="countryName"
                            labelText="Country Name"
                            {...register("countryName", {
                                required: true,
                                pattern: Pattern.nameWithoutSpace,
                            })}
                            isInvalid={!!errors.countryName}
                            required
                        />
                    ) : (
                        <Controller
                            name="country"
                            render={({ field: { onChange, value }, ref }) => (
                                <CountrySelector
                                    id="country"
                                    country={value}
                                    labelText="Country"
                                    selectCountry={onChange}
                                    {...register("country", {
                                        required: true,
                                    })}
                                    required
                                    isInvalid={!!errors.country}
                                    ref={ref}
                                />
                            )}
                            control={control}
                        />
                    )}

                    <label htmlFor="countryAvailablity">
                        <input
                            className="mr-2"
                            type="checkbox"
                            id="countryAvailablity"
                            {...register("countryAvailablity", {
                                onChange: () => {
                                    setValue("country", "");
                                    setValue("countryName", "");
                                    clearErrors("country");
                                    clearErrors("countryName");
                                },
                            })}
                        />
                        Can&apos;t find your country?
                    </label>
                </div>
            </div>
        </FormContainer>
    );
};

export default CreateForm;
